// 转债价格
import React from "react"
import { PageType, StockSubType } from "../../shared/pagetype"
import { quotedata } from "../../shared/quotedata"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"

export function KZZPrice(props: { quotedata: quotedata; detail_data: any; pagetype: PageType; stocksubtype: StockSubType }) {
  const goToPageStock = () => {
    location.href = `/quote/stock/${props.quotedata.market}.${props.detail_data.f262}.html`
  }

  return (
    <>
      {props.pagetype == PageType.沪深A股 && props.stocksubtype != StockSubType.北证A股 && props.detail_data && props.detail_data.f264 && props.detail_data.f264 != "-" && (
        <div className="ah-notice" onClick={goToPageStock}>
          <div className="ah-container">
            <p>
              <span>{single_quote[quote_item_name.转债名称](props.detail_data).element}</span>
              &nbsp;&nbsp;&nbsp;
              {single_quote[quote_item_name.转债最新价](props.detail_data).element}
              &nbsp;&nbsp;&nbsp;
              {single_quote[quote_item_name.转债涨跌幅](props.detail_data).element}
            </p>
            <p className="bottom-extra-right">
              <span>转股溢价率</span>
              {single_quote[quote_item_name.可转债转股溢价率](props.detail_data).element}
              <a>
                <i className="arrow-right-new"></i>
              </a>
            </p>
          </div>
        </div>
      )}
    </>
  )
}
